
<mat-accordion [multi]="true">


  <!-- Show all tasks -->
  <ng-container *ngIf="groups.length > 1">

    <mat-expansion-panel *ngFor="let group of groups" [expanded]="true">

      <!-- Group title -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>format_list_bulleted</mat-icon>
          <span>{{group.title}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Group elements -->
      <div class="group-container">

        <!-- Vertical bar -->
        <div class="bar"></div>

        <div class="elements">

          <div *ngFor="let element of group.elements" class="element">

            <app-timeline-element
              [group]="group"
              [element]="element"
              [canEdit]="canEdit"
              (onUpdate)="onElementUpdate($event)"
            ></app-timeline-element>

          </div>

        </div>

      </div>

    </mat-expansion-panel>

  </ng-container>


  <!-- Show only first task -->
  <div *ngIf="groups.length == 1" class="group-container">

    <!-- Vertical bar -->
    <div class="bar"></div>

    <div class="elements">
      <div *ngFor="let element of groups[0].elements" class="element">
        <app-timeline-element
          [group]="groups[0]"
          [element]="element"
          [canEdit]="canEdit"
          (onUpdate)="onElementUpdate($event)"
        ></app-timeline-element>
      </div>
    </div>
  </div>

  <!-- No task found -->
  <span *ngIf="groups.length == 0">No task found for this procedure</span>


</mat-accordion>


<!-- Group elements -->
<ng-template #groupContainer>

</ng-template>
